
import { useState } from "react";
import { useTranslation } from "react-i18next";

import EnglishFlag from "../../../assets/flags/english.svg.png";
import RussianFlag from "../../../assets/flags/russian.png";
import ChineseFlag from "../../../assets/flags/chinese.png";

import "./LanguageSelector.css";

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const [open, setOpen] = useState(false);

  const languages = [
    {
      code: "en",
      name: "English",
      flag: EnglishFlag,
    },
    {
      code: "ru",
      name: "Русский",
      flag: RussianFlag,
    },
    {
      code: "zh",
      name: "中文",
      flag: ChineseFlag,
    },
  ];

  const currentLang = i18n.language || "en";

  const selected = languages.find(
    (language) => language.code === currentLang
  );

  const changeLanguage = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className="language-selector">

      {/* Текущий язык */}
      <button
        type="button"
        onClick={() => setOpen((previous) => !previous)}
        className="language-selector__button"
      >
        <img
          src={selected?.flag}
          alt={currentLang}
          className="language-selector__current-flag"
        />
      </button>

      {/* Dropdown */}
      {open && (
        <div className="language-selector__dropdown">
          {languages.map((language) => (
            <button
              type="button"
              key={language.code}
              onClick={() => changeLanguage(language.code)}
              className="language-selector__option"
            >
              <img
                src={language.flag}
                alt={language.code}
                className="language-selector__flag"
              />

              <span className="language-selector__name">
                {language.name}
              </span>
            </button>
          ))}
        </div>
      )}

    </div>
  );
};

export default LanguageSelector;
